import { getSnapshot, types } from 'mobx-state-tree';
import { FsSingleBarGraphDataProps } from 'ui-elements/charts/FsSingleBarGraph/FsSingleBarGraph';

export interface BarGraphProps {
  title?: string;
  description?: string;
  value: number;
  maxValue: number;
}

export const BarGraph = types
  .model({
    title: types.maybe(types.string),
    description: types.maybe(types.string),
    value: types.number,
    maxValue: types.number,
  })
  .views((self) => ({
    barValue(): number {
      return (100 * self.value) / self.maxValue;
    },
  }))
  .views((self) => ({
    singleBarGraphValues(): FsSingleBarGraphDataProps {
      return {
        ...getSnapshot(self),
        barValue: self.barValue(),
      };
    },
  }));
